const definitions = {
	authenticMotion: [0.4, 0, 0.2, 1],
	bounce: [0.87, -0.41, 0.19, 1.44],
	clipped: [0.055, 0.64, 1.0, -0.59],
	in: "ease-in",
	inBack: [0.6, -0.28, 0.735, 0.045],
	inCirc: [0.6, 0.04, 0.98, 0.335],
	inExpo: [0.95, 0.05, 0.795, 0.035],
	inCubic: [0.55, 0.055, 0.675, 0.19],
	inOut: "ease-in-out",
	inOutBack: [0.68, -0.55, 0.265, 1.55],
	inOutCirc: [0.785, 0.135, 0.15, 0.86],
	inOutExpo: [1.0, 0.0, 0.0, 1.0],
	inOutQuart: [0.77, 0.0, 0.175, 1.0],
	inOutQuint: [0.86, 0.0, 0.07, 1.0],
	inOutSine: [0.445, 0.05, 0.55, 0.95],
	inQuad: [0.55, 0.085, 0.68, 0.53],
	inQuart: [0.895, 0.03, 0.685, 0.22],
	inQuint: [0.755, 0.05, 0.855, 0.06],
	inSine: [0.47, 0.0, 0.745, 0.715],
	linear: [0.25, 0.25, 0.75, 0.75],
	out: "ease-out",
	outBack: [0.175, 0.885, 0.32, 1.275],
	outCirc: [0.075, 0.82, 0.165, 1.0],
	outCubic: [0.215, 0.61, 0.355, 1.0],
	outExpo: [0.19, 1.0, 0.22, 1.0],
	outQuad: [0.25, 0.46, 0.45, 0.94],
	outQuart: [0.165, 0.84, 0.44, 1.0],
	outQuint: [0.23, 1.0, 0.32, 1.0],
	outSine: [0.39, 0.575, 0.565, 1.0],
	snap: [0.0, 1.0, 0.5, 1.0],
};

export const AUTHENTIC_MOTION = definitions.authenticMotion;
export const BOUNCE = definitions.bounce;
export const CLIPPED = definitions.clipped;
export const IN = definitions.in;
export const IN_BACK = definitions.inBack;
export const IN_CUBIC = definitions.inCubic;
export const IN_CIRC = definitions.inCirc;
export const IN_EXPO = definitions.inExpo;
export const IN_OUT = definitions.inOut;
export const IN_OUT_BACK = definitions.inOutBack;
export const IN_OUT_CIRC = definitions.inOutCirc;
export const IN_OUT_EXPO = definitions.inOutExpo;
export const IN_OUT_QUART = definitions.inOutQuart;
export const IN_OUT_QUINT = definitions.inOutQuint;
export const IN_OUT_SINE = definitions.inOutSine;
export const IN_QUAD = definitions.inQuad;
export const IN_QUART = definitions.inQuart;
export const IN_QUINT = definitions.inQuint;
export const IN_SINE = definitions.inSine;
export const LINEAR = definitions.linear;
export const OUT = definitions.out;
export const OUT_BACK = definitions.outBack;
export const OUT_CIRC = definitions.outCirc;
export const OUT_CUBIC = definitions.outCubic;
export const OUT_EXPO = definitions.outExpo;
export const OUT_QUAD = definitions.outQuad;
export const OUT_QUART = definitions.outQuart;
export const OUT_QUINT = definitions.outQuint;
export const OUT_SINE = definitions.outSine;
export const SNAP = definitions.snap;
